(ns teamoesterreich.util.download
  (:require [teamoesterreich.admin-mode.data.backend :as backend]))

(defn fetch-download-url [auth request-path callback]
  (let [url (when (not-empty request-path)
              (str backend/BASE_URL request-path))]

    (when (not-empty url)
      (-> (js/fetch url
                    #js{:headers #js{"Authorization" (str (.-token_type auth) " " (.-access_token auth))}})
          (.then (fn [response]
                   (when (.-ok response)
                     (.json response))))
          (.then (fn [body]
                   (callback (.-url body))))))
    ))

(defn fetch-blob [auth url callback]
  (when (not-empty url)
    (-> (js/fetch url
                  #js{:headers #js{"Authorization" (str (.-token_type auth) " " (.-access_token auth))}})
        (.then (fn [response]
                 (when (.-ok response)
                   (.blob response))))
        (.then callback))))

(defn download-blob [auth url filename]
  (fetch-blob auth url
              (fn [blob]
                (when blob
                  (let [url (js/URL.createObjectURL blob)
                        link (js/document.createElement "a")]
                    (set! (.-href link) url)
                    (set! (.-download link) filename)
                    (.click link)
                    (js/URL.revokeObjectURL url)
                    )))))

(defn open-download-url [auth request-path]
  (fetch-download-url auth request-path (fn [url] (js/window.open url "_blank"))))